module.exports = __webpack_public_path__ + "media/images/countrysquared/bi-9e2939a2a4fc2ffdf72cc78c7289944a.svg";